
import { t } from 'i18next';
import { Control } from 'react-hook-form';
import { ControlledTextField } from '@frontend/features/common/components/ControlledTextField';
import { Box, Typography } from '@mui/material';
import React from 'react';

export interface Pax {
  id: string;
  name: string;
  surname: string;
  dob: string;
  age: number;
}

export interface Occupancy {
  id: number;
  paxes: Pax[];
}

export interface Form {
  name: string;
  surname: string;
  email?: string | null;
}

interface Props {
  control: Control<Form>;
}

export const HolderDataForm: React.FC<Props> = ({
  control
}) => (   
  <Box
    display="flex"
    flexDirection="column"
    gap={3}
  >
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('saleOrder.view.hotels.holder.name')}</Typography>
      <ControlledTextField
        shrink
        required
        control={control}
        name="name"
        size="small"
      />
    </Box>
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('saleOrder.view.hotels.holder.lastname')}</Typography>
      <ControlledTextField
        shrink
        required
        control={control}
        name="surname"
        size="small"
      />
    </Box>
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant='subtitle2' color="text.primary">{t('saleOrder.view.hotels.holder.email')}</Typography>
      <ControlledTextField
        shrink
        control={control}
        name="email"
        size="small"
        type="email"
      />
    </Box>
  </Box>
);
